export function shouldUseTaxZipCodeForCountry(countryCode?: string) {
  return countryCode === 'US' || countryCode === 'CA';
}
